import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AdvancedOptionsSwitcherState, AdvancedOptionsSwitcherStore, SimpleActionCreator } from '../../helpers/types';

@Component({
  selector: 'app-advanced-options-switcher',
  templateUrl: './advanced-options-switcher.component.html'
})
export class AdvancedOptionsSwitcherComponent {
  @Input() action: SimpleActionCreator<any>;
  @Input() state: Observable<AdvancedOptionsSwitcherState>;

  constructor(private store: Store<AdvancedOptionsSwitcherStore>) {}

  switchAdvancedOptions() {
    this.store.dispatch(this.action());
  }
}
